<mat-card class="post">
    <mat-card-header class="mat-card-header">
        <div class="container header" >
            <img *ngIf="postData?.creatorId" mat-card-avatar [src]="creatorProfilePhotoUrl ? creatorProfilePhotoUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c' " alt="Image description"
            [routerLink]="['/postfeed/userprofile', postData?.creatorId]" class="profile-picture"/>
            
            <div class="info">
                <mat-card-title class="title" [routerLink]="['/postfeed/userprofile', postData?.creatorId]">
                    {{ creatorName }}
                    <mat-icon *ngIf="isCreatorCertified" class="certification-badge">verified</mat-icon>
                </mat-card-title>
                <mat-card-subtitle class="subtitle">{{ creatorDescription}}, {{creatorVille }}</mat-card-subtitle>
            </div>
        </div>
        <div class="options-button">
            
            <button mat-menu-item *ngIf="!isOwner" (click)="toggleFollow()" class="follow-button">
                
                
                <mat-icon *ngIf="!isFollowing">person_add</mat-icon>
                
              </button>
              <button mat-menu-item *ngIf="isOwner"  class="follow-button">
                
                
                
                
              </button>
            
            <div class="option-and-date">
                <div class="post-date"><span style="text-align: right;">{{ formattedDate }}</span></div>
                <button mat-icon-button [matMenuTriggerFor]="menu" class="option-button">
                    <mat-icon class="button-more">more_vert</mat-icon>
                </button>
            </div>
        </div>
        <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="isOwner" (click)="onEditClick()">Modifier</button>
            <button mat-menu-item *ngIf="isOwner" (click)="onDeleteClick()">Supprimer</button>
            <button mat-menu-item *ngIf="!isOwner" (click)="onMessageUser()" class="MessageOnOtherScreen">Message</button>
            <button mat-menu-item *ngIf="!isOwner" (click)="onMessageUserOnMobile()" class="MessageOnMobile">Message</button>
            <button mat-menu-item *ngIf="!isOwner && isFollowing" (click)="toggleFollow()">Se désabonner</button>
            <button mat-menu-item *ngIf="!isOwner && !isFollowing" (click)="toggleFollow()">S'abonner</button>
            <button mat-menu-item *ngIf="!isOwner">Partager</button>
            <button mat-menu-item *ngIf="!isOwner">Signaler</button>
            <!--<button mat-menu-item *ngIf="currentUserId === 'mjZ60MQCp5XmGdt0jUVMikeJggT2'" (click)="ForAgribox()">For Agribox</button>
            <button mat-menu-item *ngIf="currentUserId === 'mjZ60MQCp5XmGdt0jUVMikeJggT2'" (click)="ForLenali()">For Lenali</button>-->
        </mat-menu>
    </mat-card-header>
    
    <div class="header-divider"></div>

<!-- Image Post -->
<ng-container *ngIf="postData?.type === 'image'; else videoTemplate">
    <div class="images-container" *ngIf="getImageUrls().length > 0">
        <div class="image-item" *ngFor="let image of getImageUrls(); let i = index">
            <img [src]="image" 
                 [attr.data-index]="i"
                 alt="Post image" 
                 (click)="openImageModal(image)" 
                 (load)="onImageLoad($event)"
                 style="display: block;">
        </div>
    </div>
    <div class="media-divider" *ngIf="getImageUrls().length > 0"></div>
</ng-container>

<ng-template #videoTemplate>
    <ng-container *ngIf="postData?.type === 'video' || postData?.youtubeUrl; else photoSoundTemplate">
        <!-- Container vidéo YouTube -->
        <div class="video-container" *ngIf="postData?.youtubeUrl">
            <iframe 
                width="100%" 
                height="315" 
                [src]="postData.youtubeUrl + '?autoplay=1&enablejsapi=1' | safe:'resourceUrl'" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen
                (load)="youtubePlayerReady = true">
            </iframe>
        </div>
        
        <!-- Container vidéo normale -->
        <div class="video-container" *ngIf="postData?.videoUrl">
            <video #videoPlayer [src]="postData.videoUrl" (loadedmetadata)="onVideoLoaded($event)" (timeupdate)="onTimeUpdate($event)" [controls]="false">
                Votre navigateur ne supporte pas la lecture vidéo.
            </video>
            <div class="custom-video-controls">
                <div class="controls-left">
                  <button class="play-pause-btn" (click)="togglePlay()">
                    <mat-icon>{{isPlaying ? 'pause' : 'play_arrow'}}</mat-icon>
                  </button>
                </div>
                <div class="progress-container">
                  <input type="range" 
                         class="video-progress" 
                         [value]="currentTime" 
                         [max]="duration"
                         (input)="seekVideo($event)">
                  <div class="time-display">
                    <span class="current-time">{{formatTime(currentTime)}}</span>
                    <span class="duration">{{formatTime(duration)}}</span>
                  </div>
                </div>
                <div class="controls-right">
                  <div class="volume-control">
                    <button class="volume-btn" (click)="toggleMute()">
                      <mat-icon>{{isMuted ? 'volume_off' : (volume > 0.5 ? 'volume_up' : 'volume_down')}}</mat-icon>
                    </button>
                    <input type="range" 
                           class="volume-slider" 
                           [value]="volume * 100"
                           min="0"
                           max="100"
                           (input)="updateVolume($event)">
                  </div>
                  <button class="fullscreen-btn" (click)="toggleFullscreen()">
                    <mat-icon>{{isFullscreen ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
                  </button>
                </div>
              </div>
        </div>
        <div class="media-divider"></div>
    </ng-container>
</ng-template>

<!-- Photo Sound Post -->
<ng-template #photoSoundTemplate>
    <ng-container *ngIf="postData?.type === 'audio-image'">
        <div class="photo-sound-container">
            <!-- Container pour les images -->
            <div class="images-container" *ngIf="getImageUrls().length > 0">
                <div class="image-item" *ngFor="let image of getImageUrls(); let i = index">
                    <img [src]="image" 
                         [attr.data-index]="i"
                         alt="Post image" 
                         class="post-img" 
                         (click)="openImageModal(image)" 
                         (load)="onImageLoad($event)"
                         style="display: block;">
                </div>
            </div>

            <!-- Container pour l'audio -->
            <div class="audio-container" [ngClass]="{'audio-loading': audioLoading}">
                <audio #audioPlayer 
                       *ngIf="postData.audioUrl"
                       [src]="postData.audioUrl" 
                       (play)="onMediaPlay()"
                       (pause)="isAudioPlaying = false"
                       (loadstart)="audioLoading = true"
                       (canplay)="audioLoading = false"
                       (playing)="isAudioPlaying = true"
                       controls>
                </audio>
                <div *ngIf="audioLoading" class="audio-loading-indicator">
                    <mat-spinner diameter="36" color="accent" [strokeWidth]="3"></mat-spinner>
                </div>
            </div>
        </div>
        <div class="media-divider"></div>
    </ng-container>
</ng-template>

<!-- Audio Only Template -->
<ng-template #audioTemplate>
    <ng-container *ngIf="postData?.type === 'audio'">
        <div class="audio-container">
            <audio #audioPlayer 
                   *ngIf="postData.audioUrl"
                   [src]="postData.audioUrl" 
                   (play)="onMediaPlay()"
                   controls>
            </audio>
        </div>
        <div class="media-divider"></div>
    </ng-container>
</ng-template>

    <mat-card-content
        #postText
        class="post-text"
        [class.expanded]="isExpanded"
        [class.truncated]="isTruncated"
        (click)="toggleText()">
        {{ postData?.comment }}
    </mat-card-content>

    <!-- Prévisualisation YouTube -->
    <div *ngIf="postData?.linkPreview?.isYoutube" class="youtube-preview">
        <div *ngIf="!isYoutubeVideoPlaying" class="youtube-thumbnail" (click)="playYoutubeVideo($event)">
            <img [src]="postData.linkPreview.image" 
                [alt]="postData.linkPreview.title"
                onerror="this.src='https://img.youtube.com/vi/' + postData.linkPreview.youtubeId + '/hqdefault.jpg'">
            <div class="youtube-play-button">
                <mat-icon>play_circle_filled</mat-icon>
            </div>
            <div class="youtube-info">
                <h3>{{ postData.linkPreview.title }}</h3>
            </div>
        </div>
        
        <div *ngIf="isYoutubeVideoPlaying" class="youtube-player">
            <div class="youtube-player-header">
                <button mat-icon-button (click)="stopYoutubeVideo($event)" class="close-button">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <iframe 
                width="100%"
                height="315"
                [src]="getYoutubeEmbedUrl(postData.linkPreview.youtubeId, true) | safe:'resourceUrl'"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen>
            </iframe>
        </div>
    </div>

    <!-- Prévisualisation du lien -->
    <div *ngIf="postData?.linkPreview && !postData?.linkPreview?.isYoutube" class="link-preview-container" (click)="$event.stopPropagation()">
        <a [href]="postData.linkPreview.url" target="_blank" rel="noopener noreferrer" class="link-preview">
            <div class="link-preview-image" *ngIf="postData.linkPreview.image">
                <img [src]="postData.linkPreview.image" 
                     [alt]="postData.linkPreview.title"
                     onerror="this.style.display='none'">
            </div>
            <div class="link-preview-content">
                <h3 class="link-preview-title">{{ postData.linkPreview.title }}</h3>
                <p class="link-preview-description">{{ postData.linkPreview.description }}</p>
                <span class="link-preview-domain">
                    {{ postData.linkPreview.siteName || postData.linkPreview.url | slice:0:50 }}
                </span>
            </div>
        </a>
    </div>

    <button *ngIf="isTruncated" mat-button color="primary" (click)="toggleText()">
        {{ isExpanded ? 'Voir moins' : 'Voir plus' }}
    </button>

    
    <div class="container interaction-container">
        <div class="post-interactions">
            <!-- Bouton Aimer -->
            <div class="like">
                <button mat-icon-button (click)="toggleLike()" style=" color:  rgb(18, 170, 221);">
                    <div class="interact-row">
                        <mat-icon [ngClass]="isLiked ? 'liked' : ''" class="small-icon">{{ isLiked ? 'favorite' : 'favorite_border' }}</mat-icon> 
                        <span *ngIf="likesCount >= 0" style="color: rgb(18, 170, 221);" class="interact-text">{{ likesCount }} Likes</span>
                    </div>
                </button>
                       
            </div>
    
            <!-- Bouton Commenter -->
            <div class="commentaire">
                <button mat-icon-button (click)="onReplyClick()" style="color: rgb(18, 170, 221); ">
                    <div class="interact-row">
                        <mat-icon class=" small-icon">comment</mat-icon>
                        <span *ngIf="commentCount >= 0" style="color: rgb(18, 170, 221); text-align: center;" class="pb-2 interact-text">{{ commentCount }} commentaires</span>
                    </div>
                </button>
            </div>
    
            <!-- Bouton Partager -->
            <div class="partage">
                <button mat-icon-button (click) ="sharePost()" style="color: rgb(18, 170, 221);">
                    <div class="interact-row">
                        <mat-icon class=" small-icon">share</mat-icon>
                        <span *ngIf="sharesCount >= 0" class="interact-text">{{ sharesCount }} partages</span>
                    </div>
                </button>
            </div>
            <!-- -->
    
        </div>
    </div>
</mat-card>
<br>
